export default "__VITE_ASSET__CQCRQbuO__"